import React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import * as styles from './Languages.module.scss'
import SectionHead from '../section-head/SectionHead'
import LogoCarousel from '../logo-carousel/LogoCarousel'

const Languages: React.FC = () => {
  const t = useIntl()

  return (
    <div className={styles.container}>
      <div className={styles.head}>
        <SectionHead
          title={t.formatMessage({ id: 'languages.title' })}
          text={t.formatMessage({ id: 'languages.subtitle' })}
        />
      </div>
      <div className={styles.carousel}>
        <LogoCarousel />
      </div>
    </div>
  )
}

export default Languages
